import type {
  Estorno, SolicitarEstornoCommand, EstornoDecisaoCommand, EstornoStatus,
} from '@/domain/model/Estorno';
import type { Page } from '@/domain/model/Page';
import type { EstornoGateway } from '@/application/port/out/EstornoGateway';
import type {
  ListEstornosUseCase, SolicitarEstornoUseCase, DecidirEstornoUseCase,
  ProcessarEstornoGatewayUseCase,
} from '@/application/port/in/EstornoUseCase';

export class ListEstornos implements ListEstornosUseCase {
  constructor(private readonly g: EstornoGateway) {}
  execute(p: { status?: EstornoStatus; vendaId?: string; page?: number; size?: number }): Promise<Page<Estorno>> {
    return this.g.list(p);
  }
}
export class SolicitarEstorno implements SolicitarEstornoUseCase {
  constructor(private readonly g: EstornoGateway) {}
  execute(c: SolicitarEstornoCommand): Promise<Estorno> { return this.g.solicitar(c); }
}
export class DecidirEstorno implements DecidirEstornoUseCase {
  constructor(private readonly g: EstornoGateway) {}
  execute(id: string, c: EstornoDecisaoCommand): Promise<Estorno> { return this.g.decidir(id, c); }
}
export class ProcessarEstornoGateway implements ProcessarEstornoGatewayUseCase {
  constructor(private readonly g: EstornoGateway) {}
  execute(id: string): Promise<Estorno> { return this.g.processarGateway(id); }
}
